import { render, staticRenderFns } from "./ModalForgetPassword.vue?vue&type=template&id=d0ab9384&scoped=true&"
import script from "./ModalForgetPassword.vue?vue&type=script&lang=js&"
export * from "./ModalForgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalForgetPassword.vue?vue&type=style&index=0&id=d0ab9384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ab9384",
  null
  
)

export default component.exports